export default "__VITE_ASSET__8SYysVsJ__"